import React from 'react';
import { Box, Typography, Card, CardContent, Avatar, Button } from '@mui/material';
import { Person, FolderOpen } from '@mui/icons-material';

const ClientCard = ({ client, isIntervenant, userPractitioner, token, onOpenPatientDialog }) => {
  if (!client) return null;

  // Détection du rôle Intervenant (soit via la prop isIntervenant, soit via userPractitioner)
  const isIntervenantUser = 
    isIntervenant || 
    userPractitioner?.role_user === 3 || 
    userPractitioner?.role === 3 || 
    String(userPractitioner?.role_label || '').toLowerCase().includes('intervenant');

  const isPatient = client.is_patient === 1 && client.patient_profile;
  
  const isPractitionerAssigned = 
    userPractitioner?.role_user === 4 || 
    userPractitioner?.role === 4 ||
    String(userPractitioner?.role_label || '').toLowerCase().includes('praticien');

  // L'accès au dossier patient complet est réservé aux praticiens et non aux intervenants
  const canSeeFullMedicalProfile = !isIntervenantUser && isPatient && (isPractitionerAssigned || true);

  // Récupération sécurisée de l'ID du patient
  const patientIdToOpen = client.patient_profile?.id_patient_profile || client.id_client || client.id;

  return (
    <Card sx={{ height: '100%', borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: isIntervenantUser ? 0 : 2 }}>
          <Avatar sx={{ bgcolor: '#4318FF' }}>
            <Person />
          </Avatar>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {client.nom_client} {client.prenom_client}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {isIntervenantUser 
                ? 'Client / Participant' 
                : (canSeeFullMedicalProfile ? 'Patient - Dossier Médical Actif' : 'Client / Participant')}
            </Typography>
          </Box>
        </Box>

        {/* Si ce N'EST PAS un intervenant et qu'il a l'autorisation d'accès */}
        {!isIntervenantUser && canSeeFullMedicalProfile && (
          <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #E2E8F0' }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Email :</strong> {client.email_client}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Téléphone :</strong> {client.phone_client || 'Non renseigné'}
            </Typography>

            {/* Bouton pour ouvrir le dossier complet */}
            <Button
              variant="contained"
              startIcon={<FolderOpen />}
              onClick={() => {
                console.log("ID envoyé pour ouvrir le dossier:", patientIdToOpen);
                onOpenPatientDialog(patientIdToOpen);
              }}
              sx={{
                mt: 2,
                width: '100%',
                bgcolor: '#4318FF',
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '8px',
                '&:hover': { bgcolor: '#3311CC' }
              }}
            >
              Consulter le dossier patient ({client.patient_profile?.code_patient ? `#${client.patient_profile.code_patient}` : 'Dossier'})
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ClientCard;